export default __webpack_public_path__ + "static/axondivision-social-sharing-preview-ef4de3ba6fbefac645e7e89f7b10a150.jpg";